import { locationIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const AdminCrdbLocationSchema = z.object({
  id: locationIdFormat.schema,
  name: z.string(),
  externalId: z.string().nullish(),
});

export type AdminCrdbLocation = z.infer<typeof AdminCrdbLocationSchema>;

export const getTeamCrdbLocations = {
  name: "getTeamCrdbLocations" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ locations: z.array(AdminCrdbLocationSchema) }),
};
